// `asArray(valor, origen)` — lo que se le da de comer a un `.map()` de render.
//
// El 23-sep una respuesta de `GET /users` sin su clave `users` dejó a WAIA
// entera mostrando "Algo salió mal": `Reports` (la pantalla de `/`) hacía
// `users.map()` sobre el objeto de la respuesta. Un `.map` sobre algo que no es
// un array TIRA, y en render eso desmonta el árbol.
//
// ⚠ Esto NO es `(x || []).map()`. Esa forma tapa el bug en silencio: sobre un
// string no falla, devuelve vacío, y la pantalla queda en blanco sin que nadie
// sepa por qué — que es peor que el error, porque nadie lo mira. Acá una forma
// inesperada SIEMPRE deja rastro en consola con el origen del dato, y recién
// después se degrada a lista vacía.
//
// ⚠ Se usa SÓLO donde el dato YA llegó (después del await, dentro del render
// que el `if (!data) return` de arriba ya protegió). Por eso `undefined` también
// se loguea: ahí no significa "todavía no", significa que la respuesta vino sin
// la clave — que es justo el caso del 23-sep.
export const asArray = (valor, origen) => {
  if (Array.isArray(valor)) return valor;
  const que = valor === undefined ? "undefined (¿falta la clave?)"
    : valor === null ? "null"
    : typeof valor;
  // eslint-disable-next-line no-console
  console.error(
    `[asArray] ${origen || "origen desconocido"} devolvió ${que} en vez de un array — se usa lista vacía. Esto es un BUG del dato, no un caso normal.`,
    valor
  );
  return [];
};

export default asArray;
